export default __webpack_public_path__ + "static/media/tutorial3-7.31410f57.png";